import React from 'react';
import hotelcss from '../pages/css/hotelhotellist.module.css';
import { useState } from 'react';
import { useEffect } from 'react';
import {
    gethotelcleaners, gethistoricalhotelcleaners, updateRooster, savetotalplanned, getnexttotalplanned, getverlofaanvragenhotel_data, getView, approveRooster
} from "../dbconnector/connector";
import { setErrorMessage, setMessage } from "../tools/errorhandling";
import EmployeeRoosterNode from '../customNodes/EmployeeRoosterNode';
import Button from 'react-bootstrap/Button';
import { confirmAlert } from 'react-confirm-alert';
import { use } from 'react';
import { useMemo } from 'react';
import moment from 'moment';
import { RotatingLines } from "react-loader-spinner";
import HistorydetailsEmployee from '../customNodes/HistorydetailsEmployee';

const HotelRoosterNode = ({ rights, hotel, hotelid, t, datum }) => {

    const [error, setError] = useState({});

    const [hotelcleanersarray, sethotelcleanersarray] = useState([]);
    const [nodeArray, setnodeArray] = useState([]);
    const [hotelcleaners, sethotelcleaners] = useState([]);
    const [roosterinfo, setroosterinfo] = useState({});
    const [totalhotel, setTotalhotel] = useState({});
    const [needupdate, setNeedupdate] = useState(false);
    const [hotelnormen, sethotelnormen] = useState({});
    const [forceRender, setForceRender] = useState(false);

    const [holidays, setholidays] = useState([]);
    const [isFinal, setIsFinal] = useState(false);
    const [canEdit, setCanEdit] = useState(true);
    const [isApproved, setisApproved] = useState(false);
    const [isHistory, setisHistory] = useState(false);
    const prevCSS = React.useRef(0)
    const prevSelectedRecord = React.useRef(0)
    const [nrofRooms, setnrofRooms] = useState(0);
    const [totals, setTotals] = useState({});
    const [employee, SetEmployee] = useState({});
    const [dragwindow, setDragWindow] = useState(false);
    const [windowtodrag, setWindowtodrag] = useState(null);
    const [left, setleft] = useState(0);
    const [top, settop] = useState(0);
    let blijvers = [];
    let vertrekkers = [];
    let AD = [];
    let Norm = [];
    let employeeHours = [];



    useEffect(() => {
        document.getElementById("FullscreenBlocker").style.display = "none";
        getData(hotelid)
        GetHotelGenerals(hotelid)
    }, [hotelid]);


    const GetHotelCleaners = (HotelId) => {
        if (HotelId) {
            gethotelcleaners(HotelId).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        //setIsFinal(false);
                        setCanEdit(true);
                        //console.log("gethotelcleaners", res.items)
                        sethotelcleaners(res.items)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }
    const GethistoricalHotelCleaners = (HotelId) => {
        if (HotelId) {

            gethistoricalhotelcleaners(HotelId).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        setCanEdit(false);
                        //console.log("GethistoricalHotelCleaners ", res.items)
                        sethotelcleaners(res.items)

                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }
    const startdrag = (windowname, drag, e) => {
        console.log(windowname)
        setWindowtodrag(windowname)
        var rect = e.target.getBoundingClientRect();
        setleft(e.clientX - rect.left)
        settop(e.clientY - rect.top)
        setDragWindow(drag)
    }
    const MouseMove = (e) => {
        if (dragwindow === true && windowtodrag !== null) {
            document.getElementById(windowtodrag).style.top = (e.clientY - (10 - window.pageYOffset)) + "px"
            document.getElementById(windowtodrag).style.left = (e.clientX - (left - window.pageXOffset)) + "px"
        }
    }
    const showhistoricaldetails = (employee) => {
        //// //console.log("employee = ", employee)
        SetEmployee(employee)
        document.getElementById("coverAll").style.display = 'block'
    }
    const GetHotelGenerals = (HotelId) => {
        if (HotelId) {
            getView("hotelgenerals", "HotelID", HotelId).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        ////console.log"nrofrooms :", res[0])
                        if (res[0] !== undefined) {
                            setnrofRooms(res[0].nrofrooms)
                        } else {
                            setnorm(1, 1)
                            sethotelnormen(
                                {
                                    norm: {

                                        blijversad: 1,
                                        flitsad: 1,
                                        hotel_Id: HotelId,
                                        vertrekkersad: 1
                                    }
                                }
                            )


                        }
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }

    }
    const GetHotelNormen = (HotelId) => {
        if (HotelId) {
            sethotelnormen([]);
            getView("hotelaverage_productivity", "hotel_id", HotelId).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        res.forEach((norm => {
                            if (norm.hotel_Id === hotelid) {
                                sethotelnormen((pre) => {

                                    if (norm.blijversad === null || norm.vertrekkersad === null) {
                                        setMessage(t("NORM_NOT_DEFINED"))
                                    }
                                    else {
                                        setnorm(norm.blijversad, norm.vertrekkersad)
                                    }
                                    return {
                                        ...pre,
                                        norm
                                    }
                                })
                            }
                        }))
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const checkcleanerTotalHours = (minutes, employeeid, index) => {
        // ////////////console.log"minutes = ", minutes)
        // ////////////console.log"employeeid = ", employeeid)
        // ////////////console.log"index = ", index)
        let totalminutes = 0;
        if (employeeHours.find(({ key }) => key === index) === undefined) {
            employeeHours.push({ key: index, data: { minutes: minutes, employeeid: employeeid, index: index } })
        } else {
            employeeHours.find(({ key }) => key === index).data = { minutes: minutes, employeeid: employeeid, index: index }
        }

        employeeHours.forEach((val, index) => {
            if (val.data.employeeid === employeeid) {
                totalminutes = totalminutes + val.data.minutes
            }
        })
        if (totalminutes >= 600) {
            employeeHours.forEach((val, index) => {
                if (val.data.employeeid === employeeid) {
                    document.getElementById(employeeid + "_" + val.data.index + "?blijver").className = "gridinput redborder"
                    document.getElementById(employeeid + "_" + val.data.index + "?vertrekker").className = "gridinput redborder"
                    document.getElementById(employeeid + "_" + val.data.index + "?AD").className = "gridinput redborder"
                }
            })
        }
        if (totalminutes < 600) {
            employeeHours.forEach((val, index) => {
                if (val.data.employeeid === employeeid) {
                    document.getElementById(employeeid + "_" + val.data.index + "?blijver").className = "gridinput"
                    document.getElementById(employeeid + "_" + val.data.index + "?vertrekker").className = "gridinput"
                    document.getElementById(employeeid + "_" + val.data.index + "?AD").className = "gridinput"
                }
            })
        }
        ////////////console.log"totalminutes =", totalminutes)
    }


    const addcleaner = (cleaner, index) => {
        // //console.log("addcleaner: ", cleaner)
        ////////////console.log"hotelcleanersarray", hotelcleanersarray);
        const data = CheckHolidayofuser(cleaner.werknemers_ID);
        const hasholiday = (data && data.length > 0);
        // const noneworkinday = (data && data.length > 0);

        sethotelcleanersarray(pre => {
            const findindex = pre.findIndex((item) => item.Employee.id === cleaner.id);
            calctotal("blijver", 0, 0, cleaner.werknemers_ID, "addcleaner");
            calctotal("vertrekker", 0, 0, cleaner.werknemers_ID, "addcleaner");
            calctotal("AD", 0, 0, cleaner.werknemers_ID, "addcleaner");

            const newProps = {
                dataishere: true,
                data: [{ ...cleaner }],
                translation: t,
                setNeedupdate,
                Employee: { ...cleaner },
                hasholiday: hasholiday,
                index: pre.length,
                events: {
                    selectrow, calc, calctotal, fillblijver, fillvertrekker, fillAD, fillnorm,
                    duplicateroosternode, addcleaner, removecleaner, checkcleanerTotalHours, addEmployeeRoosterNode, changecleanerprops, showhistoricaldetails
                },
                hotelid,
                datum,
                hotelnormen,
                disabled: isFinal,
                canEdit: canEdit,
                isapproved: isApproved,
                sortedCleaners: true,
                wasActiveInPeriod: true
            }
            const newArray = [...pre.slice(0, findindex),
                newProps,
            ...pre.slice(findindex)
            ]
            //// //console.log("newArray A", newArray)
            return newArray
        })
    }

    const removecleaner = (cleaner, index) => {

        sethotelcleanersarray(pre => {
            const findindex = pre.findIndex((item) => {
                ////////console.log"removecleaner", item.Employee.id + "_" + item.index, "===", cleaner)
                return item.Employee.id + "_" + item.index === cleaner
            });
            ////////////console.log"findindex", findindex);
            if (findindex !== -1) {
                const newArray = [
                    ...pre.slice(0, findindex),
                    ...pre.slice(findindex + 1)
                ];

                return newArray;
            } else {
                return pre; // Return the original array if the cleaner is not found
            }
        });
    }

    const changecleanerprops = (classindex, variable, Employee) => {
        setnodeArray([])
        blijvers = [];
        vertrekkers = [];
        AD = [];
        Norm = [];
        employeeHours = [];
        const data = CheckHolidayofuser(Employee.werknemers_ID);
        const hasholiday = (data && data.length > 0);
        sethotelcleanersarray(pre => {
            const oldprops = pre[classindex];
            const newProps = {
                ...oldprops,
                dataishere: true,
                data: [{ ...variable }],
                Employee: Employee,
                translation: t,
                setNeedupdate,
                hasholiday,
                events: {
                    selectrow, calc, calctotal, fillblijver, fillvertrekker, fillAD, fillnorm,
                    duplicateroosternode, addcleaner, removecleaner, checkcleanerTotalHours, addEmployeeRoosterNode, changecleanerprops, showhistoricaldetails
                },
                hotelid,
                datum,
                hotelnormen,
                disabled: isFinal,
                canEdit: canEdit,
                isapproved: isApproved,
                wasActiveInPeriod: true

            };
            const updatedArray = [
                ...pre.slice(0, classindex),
                newProps,
                ...pre.slice(classindex + 1)
            ];

            return updatedArray;
        });

        // Force re-render
        setForceRender(prev => !prev);
    }


    const addEmployeeRoosterNode = (props) => {
        sethotelcleanersarray((pre) => {
            // //console.log("sethotelcleanersarray =" ,pre)
            let newArray = [...pre];

            props.forEach(prop => {
                if (prop.index !== undefined) {
                    const newProps = {
                        ...prop.node,
                        index: prop.index,
                        dataishere: true,
                        wasActiveInPeriod: true
                    };

                    calctotal("blijver", prop.node.blijver, 0);
                    calctotal("vertrekker", prop.node.vertrekker, 0);
                    calctotal("AD", prop.node.AD, 0);
                    calctotal("vrij", prop.node.vrij, 0);
                    calctotal("norm", prop.node.norm, 0);


                    const exists = newArray.some(a => {
                        return (a.index + "_" + a.Employee.id) === (prop.index + "_" + prop.node.Employee.id);
                    });

                    if (!exists) {

                        const findindex = newArray.findIndex(a => a.Employee.id === prop.node.Employee.id);

                        newArray = [
                            ...newArray.slice(0, findindex + 1),
                            { ...newProps, hotelnormen: hotelnormen },
                            ...newArray.slice(findindex + 1)
                        ];
                    }
                }
            });
            return newArray;
        });
    };


    useEffect(() => {

        if (hotelcleaners.length > 0) {
            const newArray = hotelcleaners.map((cleaner, index) => {
                var wasActiveInPeriod = true;
                if (cleaner.actief === 0) {
                    var uitdienstdatum = moment.utc(new Date(cleaner.uit_dienstdatum), "YYYY-MM-DD").add(1, 'day');
                    var indienstdatum = moment.utc(new Date(cleaner.in_dienstdatum), "YYYY-MM-DD");
                    var requestedrooster = moment.utc(new Date(datum), "YYYY-MM-DD");
                    wasActiveInPeriod = moment(requestedrooster).isBetween(indienstdatum, uitdienstdatum);
                }
                const data = CheckHolidayofuser(cleaner.id);
                const hasholiday = (data && data.length > 0);
                // if (wasActiveInPeriod) {
                return {
                    dataishere: false,
                    Employee: cleaner,
                    translation: t,
                    index,
                    setNeedupdate,

                    hasholiday,

                    events: {
                        selectrow, calc, calctotal, fillblijver, fillvertrekker, fillAD, fillnorm,
                        duplicateroosternode, addcleaner, removecleaner, checkcleanerTotalHours, addEmployeeRoosterNode, changecleanerprops, showhistoricaldetails
                    },
                    hotelid,
                    datum,
                    hotelnormen,
                    disabled: isFinal,
                    canEdit: canEdit,
                    isapproved: isApproved,
                    wasActiveInPeriod: wasActiveInPeriod
                }
                // }
            });
            sethotelcleanersarray(newArray);
        }
    }, [holidays, hotelcleaners]);

    useEffect(() => {

        sethotelcleanersarray(prev => {
            return prev.map(cleaner => {
                if (cleaner !== undefined) {
                    return { ...cleaner, saveError: error[cleaner.Employee.id] }
                }
            });
        }
        )
    }, [error]);

    const sortedCleaners = useMemo(() => {
        ////console.log"sortedCleaners", error);
        return [...hotelcleanersarray].sort((a, b) => {
            if (a.Employee.id === b.Employee.id) {
                return a.index - b.index;
            }
            return a.Employee.voornaam.localeCompare(b.Employee.voornaam);
        })


    }, [hotelcleanersarray, error]);


    const getData = (hotelid) => {
        GetHolidays(hotelid, datum, datum)
        var currentdate = moment.utc(new Date(), "YYYY-MM-DD");
        var requestedrooster = moment.utc(new Date(datum), "YYYY-MM-DD");
        var historicalview = moment(requestedrooster).isSameOrBefore(currentdate);
        GetHotelNormen(hotelid);
        gettotalplannedData(hotelid)
        if (!historicalview) {
            GetHotelCleaners(hotelid);
        } else {
            //if( moment(requestedrooster).isSame(currentdate)){ setIsFinal(false);}else{ setIsFinal(true);}
            GethistoricalHotelCleaners(hotelid);
        }

    }

    function CheckHolidayofuser(userid) {
        var data = holidays.filter(item => (item.werknemers_Id === userid && item.status === 2))
        if (data.length > 0) {
            return data
        } else {
            return false
        }
    }


    useEffect(() => {
        calcpercent("blijver", document.getElementById("blijver").offsetWidth, document.getElementById("blijver").value, document.getElementById("blijver_calc").value)
        calcpercent("vertrekker", document.getElementById("vertrekker").offsetWidth, document.getElementById("vertrekker").value, document.getElementById("vertrekker_calc").value)
        calcpercent("AD", document.getElementById("AD").offsetWidth, document.getElementById("AD").value, document.getElementById("AD_calc").value)
        calcpercent("norm", document.getElementById("norm").offsetWidth, document.getElementById("norm").value, Number(document.getElementById("norm_calc").value).toFixed(2))
    }, [totalhotel]);

    const GetHolidays = (HotelId, date_start, date_end) => {
        setholidays([])
        if (HotelId) {
            getverlofaanvragenhotel_data(HotelId, date_start, date_end).then(res => {
                if (res.status === 200) {
                    res.json().then(res => {
                        setholidays(res)
                    })
                } else {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }
    function addDays(date, days) {
        const newDate = new Date(date);
        newDate.setDate(date.getDate() + days);
        return newDate;
    }
    const gettotalplannedData = (hotelid) => {
        console.log("gettotalplannedData res", datum)
        let isInPast = false
        var today = moment.utc(addDays(new Date(), 0).toLocaleDateString('en-CA'), "YYYY-MM-DD");
        var requestedrooster = moment.utc(new Date(datum), "YYYY-MM-DD");
        isInPast = moment(requestedrooster).isBefore(today)

        console.log(requestedrooster, today)

        getnexttotalplanned(hotelid, datum).then(res => {

            if (res.status === 200) {
                res.json().then(res => {
                    setTotalhotel(res)
                    if (isInPast) {
                        setIsFinal(isInPast);
                        setisApproved(isInPast);
                        setisHistory(isInPast)
                    } else {
                        setIsFinal(res.final);
                        setisApproved(res.approved);
                        setisHistory(isInPast)
                    }
                })
            } else {
                setTotalhotel({
                    blijver: 0,
                    vertrekker: 0,
                    AD: 0,
                    norm: 0
                })
                if (isInPast) {
                    setIsFinal(false);
                    setisApproved(false);
                    setisHistory(isInPast)
                } else {
                    setIsFinal(isInPast);
                    setisApproved(isInPast);
                    setisHistory(isInPast)
                }
            }
        })

    }

    const fillblijver = (nodeid, value) => {
        //////console.lognodeid, value)
        setTotals(prev => ({
            ...prev,
            [nodeid]: {
                ...prev[nodeid],
                blijver: value
            }
        }));
    }

    const fillvertrekker = (nodeid, value) => {
        //////console.lognodeid, value)
        setTotals(prev => ({
            ...prev,
            [nodeid]: {
                ...prev[nodeid],
                vertrekker: value
            }
        }));
    }

    const fillAD = (nodeid, value) => {
        //////console.lognodeid, value)
        setTotals(prev => ({
            ...prev,
            [nodeid]: {
                ...prev[nodeid],
                AD: value
            }
        }));
    }

    const fillnorm = (nodeid, value) => {
        setTotals(prev => ({
            ...prev,
            [nodeid]: {
                ...prev[nodeid],
                norm: value
            }
        }));
    }

    const selectrow = (fieldname, rowid, event) => {
        //////////////console.log"rowid", rowid)
        if (prevCSS.current !== undefined && prevSelectedRecord.current !== undefined) {
            if (document.getElementById(prevSelectedRecord.current)) {
                document.getElementById(prevSelectedRecord.current).className = prevCSS.current;
            }
        }
        prevCSS.current = document.getElementById(rowid).className;
        prevSelectedRecord.current = rowid
        document.getElementById(rowid).className = hotelcss.rooster_tableselectedRow

        if (document.activeElement.id.split("?")[0].toString() !== rowid.toString() && event === "click") {
            document.getElementById(rowid + "?blijver").focus()
        }
    }

    useEffect(() => {
        //////console.logtotals)
        calc()
    }, [totals]);

    const calc = () => {
        let blijverTotal = 0;
        let vertrekkerTotal = 0;
        let adTotal = 0;
        let normTotal = 0;

        // Sum the values
        for (const nodeId in totals) {
            const node = totals[nodeId];
            if (node.blijver !== undefined)
                blijverTotal += node.blijver;
            if (node.vertrekker !== undefined)

                vertrekkerTotal += node.vertrekker;
            if (node.AD !== undefined)
                adTotal += node.AD;
            if (node.norm !== undefined)
                normTotal += Number(node.norm); // Use 0 if norm is undefined
        }

        // Update the HTML elements
        if (document.getElementById("blijver_calc") !== null) {
            document.getElementById("blijver_calc").value = blijverTotal;
            calctotal("blijver", blijverTotal);

        }
        if (document.getElementById("vertrekker_calc") !== null) {

            document.getElementById("vertrekker_calc").value = vertrekkerTotal;
            calctotal("vertrekker", vertrekkerTotal);
        }

        if (document.getElementById("AD_calc") !== null) {

            document.getElementById("AD_calc").value = adTotal;
            calctotal("AD", adTotal);
        }

        //////console.log"normTotal", normTotal)
        if (document.getElementById("norm_calc") !== null) {

            document.getElementById("norm_calc").value = normTotal;
            calctotal("norm", normTotal);
        }

    }
    const calctotal = (id, total) => {
        if (total !== undefined) {
            if (id === "norm" && document.getElementById(id + "_calc_view") !== null) {
                document.getElementById(id + "_calc_view").value = Math.floor(Number(total))
                calcpercent(id, document.getElementById(id).offsetWidth, document.getElementById(id).value, Math.floor(Number(total)))
            }
            else if (document.getElementById(id) !== null) {
                calcpercent(id, document.getElementById(id).offsetWidth, document.getElementById(id).value, total)
            }
        }
    }
    const calcpercent = (id, targetwidth, targetvalue, value) => {
        if (document.getElementById(id + "_calc") !== null) {
            document.getElementById(id + "_calc").style.width = targetwidth + "px"
        }
        let pxwidth = targetwidth / (targetvalue / value)
        if (document.getElementById(id + "_percent") !== null) {
            document.getElementById(id + "_percent").style.width = pxwidth + "px"
            if (pxwidth < targetwidth) {
                document.getElementById(id + "_percent").style.backgroundColor = "blue"
                document.getElementById(id + "_percent").style.width = pxwidth + "px"
            } else if (pxwidth > targetwidth) {
                document.getElementById(id + "_percent").style.backgroundColor = "red"
                document.getElementById(id + "_percent").style.width = targetwidth + "px"
            } else if (pxwidth === targetwidth) {
                document.getElementById(id + "_percent").style.backgroundColor = "green"
                document.getElementById(id + "_percent").style.width = targetwidth + "px"
            }
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault();
        update(false);
    }

    const update = (approved) => {
        document.getElementById("FullscreenBlocker").style.display = "block";
        document.getElementById("RotatinglinesText").innerText = "rooster wordt gevalideerd, even geduld"
        const roosterform = document.getElementById("roosterform");
        const form = new FormData(roosterform)

        const jsonobject = Object.fromEntries(form.entries())
        const filteredkeys = Object.keys(jsonobject).filter((item) => ["AD", "vertrekker", "blijver", "norm"].includes(item))
        filteredkeys.forEach((key) => {
            delete jsonobject[key]
        })
        return updateRooster(hotelid, jsonobject, datum, approved).then(res => {
            if (res.status === 200) {
                setError({})
                res.json().then(body => {
                    if (Object.keys(body).length > 0) {
                        for (const key in body) {
                            setError(pre => ({ ...pre, [key]: body[key].data.fullname + t("already _scheduled") + body[key].conflict.map((a, ind) => ind === 0 ? " " + a.Name : ", " + a.Name) + t("for_selected_time") }))
                        }
                        setMessage(t("message_errors_in_schedule_detected"))
                    } else {
                        setMessage(t('Scheduleupdatedfor') + "'" + hotel.Name + "'")
                        getData(hotelid);
                    }
                })
                document.getElementById("FullscreenBlocker").style.display = "none";
            } else {
                document.getElementById("FullscreenBlocker").style.display = "none";
                setErrorMessage(res.statusText)
            }
        })
    }

    const oncalcnorm = (typename, value) => {
        let enteredvalue = document.getElementById(typename).value;
        let averagderoomtypevalue = value;
        let averagdehoursdayvalue = 1;
        return (enteredvalue / averagderoomtypevalue) / averagdehoursdayvalue
    }

    const setnorm = (blijvernorm, vertrekkersnorm) => {
        let norm = oncalcnorm("blijver", blijvernorm) + oncalcnorm("vertrekker", vertrekkersnorm) + Number(document.getElementById("AD").value);
        document.getElementById("norm").value = Math.floor(norm)
        setTotalhotel({ ...totalhotel, "norm": norm })
    }
    const duplicateroosternode = (copynode) => {


        // updateRooster(copynode.hotel_Id, copynode, datum).then(res => {
        //     if (res.status === 200) {
        //         setMessage(t('Scheduleupdatedfor') + "'" + hotel.Name + "'")
        //         GetHotelCleaners(hotelid)
        //     } else {
        //         setErrorMessage(res.statusText)
        //     }
        // })
    }

    const onchangetotalhotel = (e) => {
        const blijver = document.getElementById("blijver").value;
        const vertrekker = document.getElementById("vertrekker").value;
        const totalinput = Number(vertrekker) + Number(blijver)
        //////////////console.logtotalinput,"<= ", nrofRooms)
        if (totalinput > nrofRooms) {
            setMessage(t('warning_MaxnrOfRoomsExceeded') + nrofRooms)
        }
        setnorm(hotelnormen.norm.blijversad, hotelnormen.norm.vertrekkersad);
        setTotalhotel({ ...totalhotel, [e.target.name]: e.target.value })
        if (e.target.value !== "") {
            let form = {}
            form[e.target.name] = e.target.value
            savetotalplanned(hotelid, form, datum).then(res => {
                if (res.status !== 200) {
                    setErrorMessage(res.statusText)
                }
            })
        }
    }

    const savefinal = async (e) => {
        let form = {}
        form["final"] = !isFinal
        await savetotalplanned(hotelid, form, datum).then(res => {
            if (res.status !== 200) {
                setErrorMessage(res.statusText)
            }
        })
        if (!isFinal) {
            await update(false)
        }
        getData(hotelid);
    }

    const saveapprove = async (e) => {
        let form = {}
        form["approved"] = true
        form["final"] = true
        await savetotalplanned(hotelid, form, datum).then(res => {
            if (res.status !== 200) {
                setErrorMessage(res.statusText)
            }
        })

        if (!isFinal) {
            await update(true)
        }
        else {
            approveRooster(hotelid, datum, true)
        }
        getData(hotelid);
    }

    const handlesavefinalClick = () => {
        const options = {
            title: isFinal ? t("Remove lock?") : t("Schedule ready?"),
            message: !isFinal ? t("Do you want to send in the schedule of") + hotel.Name + t("in for approval") : t("Do you want to remove the finalised block from the schedule of") + hotel.Name + "' ?",
            buttons: [
                {
                    label: 'Yes',
                    onClick: async () => {
                        await savefinal();
                    }
                },
                {
                    label: 'No',
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }

    const handlesaveApproveClick = () => {
        const options = {
            title: t('Approve?'),
            message: t("Do you want to Approve the schedule of") + hotel.Name + t("Notifications will be sent to the users after you approve the schedule"),
            buttons: [
                {
                    label: t('Yes'),
                    onClick: () => {
                        saveapprove();
                    }
                },
                {
                    label: t('No'),
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
            overlayClassName: "overlay-custom-class-name"
        };

        confirmAlert(options)

    }



    return (
        <>
            <div className="fullscreen" id="FullscreenBlocker">
                <div id="Rotatinglines" className="checkingatworkstatusmessage">
                    <center>
                        <RotatingLines
                            strokeColor="grey"
                            strokeWidth="5"
                            animationDuration="0.75"
                            visible={true} className="spinner"
                        />
                        <br></br>
                        <div id="RotatinglinesText">Gegevens worden verwerkt, even geduld aub</div>
                    </center>
                </div>
            </div>
            <form id="roosterform" onSubmit={handleSubmit}>
                <div className="tabpanel">
                    <div key="headertabled0" id="headertabled" className={hotelcss.totals_rooster} >
                        <p key="headertabled01">{t('Totalen')}  {hotel.Name}</p>
                        <input key="headertabled02" disabled={isFinal || isApproved} type="number" id="blijver" name={"blijver"} onChange={onchangetotalhotel} value={totalhotel.blijver} className="gridinput" ></input>
                        <input key="headertabled03" disabled={isFinal || isApproved} type="number" id="vertrekker" name={"vertrekker"} onChange={onchangetotalhotel} value={totalhotel.vertrekker} className="gridinput"></input>
                        <input key="headertabled04" disabled={isFinal || isApproved} type="decimal" id="AD" name={"AD"} onChange={onchangetotalhotel} value={totalhotel.AD} className="gridinput"  ></input>
                        <p key="headertabled05">&nbsp;</p>
                        <p key="headertabled06">&nbsp;</p>
                        <p key="headertabled07">&nbsp;</p>
                        <p key="headertabled08">&nbsp;</p>
                        <p key="headertabled09">&nbsp;</p>
                        <p key="headertabled010">&nbsp;</p>
                        <p key="headertabled011">&nbsp;</p>
                        <input key="headertabled012" type="number" id="norm" className="gridinput" disabled></input>
                    </div>
                    <div key="headertabled1" id="headertabled" className={hotelcss.totals_roostercalc}>
                        <p key="headertabled11"></p>
                        <div key="headertabled12" disabled={isFinal || isApproved} id="blijver_percent" className={hotelcss.percentdiv}><input type="number" id="blijver_calc" className={hotelcss.gridinputcalc} disabled></input></div>
                        <div key="headertabled13" disabled={isFinal || isApproved} id="vertrekker_percent" className={hotelcss.percentdiv}><input type="number" id="vertrekker_calc" className={hotelcss.gridinputcalc} disabled></input></div>
                        <div key="headertabled14" disabled={isFinal || isApproved} id="AD_percent" className={hotelcss.percentdiv}><input type="number" id="AD_calc" className={hotelcss.gridinputcalc} disabled></input></div>
                        <p key="headertabled15">&nbsp;</p>
                        <p key="headertabled16">&nbsp;</p>
                        <label key="headertabled17" ><div className={hotelcss.labelheadercol}><center>{t('Voormiddag')}</center></div></label>
                        <p key="headertabled18">&nbsp;</p>
                        <label key="headertabled19" ><div className={hotelcss.labelheadercol}><center>{t('Namiddag')}</center></div></label>
                        {/* <p key="headertabled110">&nbsp;</p> */}
                        <div key="headertabled112" id="norm_percent" className={hotelcss.percentdiv}><input type="number" id="norm_calc_view" className={hotelcss.gridinputcalc} disabled></input></div>
                        <div key="headertabled111" id="norm_percen_view" className={hotelcss.percentinvisible}><input type="number" id="norm_calc" className={hotelcss.gridinputcalc} disabled></input></div>

                    </div>
                    <div key="headertabled2" id="headertabled" className={hotelcss.rooster_tableheader}>
                        <p id="status" key="headertabled21">{t('Medewerker')}</p>
                        <p id="type" key="headertabled22">{t('Blijver')}</p>
                        <p id="type" key="headertabled23">{t('Vertrekker')}</p>
                        <p id="type" key="headertabled24">{t('AD')}</p>
                        <p id="type" key="headertabled25">&nbsp;</p>
                        <p id="type" key="headertabled26">{t('SuperHours')}</p>
                        <div className={hotelcss.gridLineR_header}>
                            <p id="VM_Beginuur" key="headertabled27" >{t('Beginuur')}</p>
                        </div>
                        <div className={hotelcss.gridLineL_header}>
                            <p id="VM_Einduur" key="headertabled28">{t('Einduur')}</p>
                        </div>
                        <p id="Pauze" key="headertabled29">{t('Pauze')}</p>
                        <div className={hotelcss.gridLineR_header}>
                            <p id="NM_Beginuur" key="headertabled210">{t('Beginuur')}</p></div>
                        <div className={hotelcss.gridLineL_header}>
                            <p id="NM_Einduur" key="headertabled211">{t('Einduur')}</p>
                        </div>
                        <p id="NM_type" key="headertabled212">{t('Norm')}</p>
                    </div>
                    <div id='Cleanerlist' className='list'>
                        {sortedCleaners.map((props, idx) => {
                            //console.log("props", props)
                            //console.log("wasActiveInPeriod", props.wasActiveInPeriod)
                            if (props !== undefined && props.wasActiveInPeriod === true) {
                                const data = CheckHolidayofuser(props.Employee.id);
                                const hasholiday = (data && data.length > 0);
                                return (
                                    <EmployeeRoosterNode
                                        key={props.Employee.id + "_" + props.index}
                                        {...props}
                                        classindex={idx}
                                        hotelnormen={hotelnormen}
                                        disabled={isFinal}
                                        canEdit={props.canEdit}
                                        isApproved={isApproved}
                                        hasholiday={hasholiday}
                                    />
                                )
                            }
                        })}
                    </div>

                    <div id="saveDiv" class="three_Buttons">
                        <Button type="submit" style={{ display: needupdate ? "none" : "block", visibility: !isHistory ? "visible" : "hidden" }} id="saveButton" className="Savebutton btn btn-primary margin-right" disabled={isFinal || isApproved}>{t('BewarenRooster')} '{hotel.Name}'</Button>
                        <Button type="button" style={{ display: needupdate ? "block" : "none", visibility: !isHistory ? "visible" : "hidden" }} id="updateButton" className="Savebutton btn btn-primary margin-right" disabled={isFinal || isApproved} onClick={update}>{isApproved ? t("scheduleApproved") : isFinal ? t("ScheduleSendForApproval") : (t('updateRooster') + " " + hotel.Name)} </Button>
                        <Button type="button" id="cancelButton" className="Savebutton btn btn-primary margin-right" style={{ "background-color": "RED", visibility: !isHistory ? "visible" : "hidden" }} disabled={Object.keys(error).length > 0 ? true : isFinal ? [2, 4].includes(rights) ? isApproved : true : false} onClick={handlesavefinalClick}>{Object.keys(error).length > 0 ? t("Resolve_conflicts") : isFinal && [2, 4].includes(rights) ? t("Remove_lock") : isFinal ? t("ScheduleSendForApproval") : t("SendScheduleForApproval")}</Button>
                        <Button type="button" id="cancelButton" className="Savebutton btn btn-primary margin-right" style={{ "background-color": "GREEN", display: [2, 4].includes(rights) ? "block" : "none", visibility: !isHistory ? "visible" : "hidden" }} disabled={isApproved} onClick={handlesaveApproveClick}>{isFinal && [2, 4].includes(rights) ? isApproved ? t("Already_been_approved") : t("Approve") : t("Approve_anyway")}</Button>
                    </div>
                </div>
            </form>
            <div id="coverAll" className="subscreen" onMouseMove={MouseMove}>
                <HistorydetailsEmployee rights={rights} t={t} employee={employee}
                    events={{
                        startdrag: startdrag
                    }}
                ></HistorydetailsEmployee>
            </div>
        </>
    );
}


export default HotelRoosterNode;
